<script setup lang="ts">
definePageMeta({
  name: "index",
  layout: "app",
});

const { loggedIn } = useUserSession();
</script>

<template>
  <LazyWebDashboard v-if="loggedIn" />
  <LazyWebWelcome v-else />
</template>
